import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'purchase';

export const state = {
    orgId: UserPersistence.getOrgId(),
    isShow: true,
    PurchaseDetails: '',
    PurchaseId: '',
    abId: '',
    accountInfo: {},
    routerUrl: '',
    isView: false,
    disable: false,
    buttonType: '',
    params: null,
    billCode: ''
}
export const mutations = {
    setPurchaseDetails(state, data) {
        state.PurchaseDetails = data
    },
    setPurchaseIsShow(state, flag) {
        state.isShow = flag
    },
    setOrgId(state, id) {
        state.orgId = id
    },
    setPurchaseId(state, data) {
        state.PurchaseId = data.id
        state.abId = data.abId
    },
    setAccountInfo(state, data) {
        state.accountInfo = data
    },
    setPurchaseRouterUrl(state, url) {
        state.routerUrl = url
    },
    setPurchaseIsView(state, flag) {
        state.isView = flag
    },
    setPurchaseDisable(state, flag) {
        state.disable = flag
    },
    setButtonType(state, type) {
        state.buttonType = type
    },

    setParams(state, data) {
        state.params = data
    },
    setBillCode(state, code) {
        state.billCode = code
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/purchase-manage/index.js